import { http } from '../plugins/http'

interface AuthResponse {
  access_token: string
  expires_in: number
  refresh_token: string
  token_type: string
}

export default class AuthService {
  private client = {
    id: import.meta.env.VITE_API_ID,
    secret: import.meta.env.VITE_API_SECRET,
  }

  async auth(username: string, password: string): Promise<string> {
    const { data } = await http.post<AuthResponse>(`/oauth/token`, {
      username: username,
      password: password,
      client_id: this.client.id,
      client_secret: this.client.secret,
      grant_type: 'password',
      scope: '*',
    })

    return data.access_token
  }
}
